import { render, staticRenderFns } from "./inspection_page.vue?vue&type=template&id=f689a9cc&scoped=true"
import script from "./inspection_page.vue?vue&type=script&lang=js"
export * from "./inspection_page.vue?vue&type=script&lang=js"
import style0 from "./inspection_page.vue?vue&type=style&index=0&id=f689a9cc&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f689a9cc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\2026\\Halov2-Fishery-Upgrade\\halov-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f689a9cc')) {
      api.createRecord('f689a9cc', component.options)
    } else {
      api.reload('f689a9cc', component.options)
    }
    module.hot.accept("./inspection_page.vue?vue&type=template&id=f689a9cc&scoped=true", function () {
      api.rerender('f689a9cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/iot/inspection/inspection_page.vue"
export default component.exports